import { apiservice } from "../service/service";

export async function authActionLogin(body) {
  try {
    const response = await apiservice({
      path: "/authen/login",
      method: "post",
      body,
    });
    if (response.status == 200) {
      console.log("login", response);
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}
export async function getActionUser(token) {
  try {
    const response = await apiservice({
      path: "/user/getuser",
      method: "get",
      token: token?.accessToken,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
